export default "__VITE_ASSET__BDPBbf_H__"